/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\router\index.js                                                  *
 * Project: Telemedicine-MyMedicine                                            *
 * Created Date: Monday, April 3rd 2023, 11:20:44 am                           *
 * Author: Shyam Mohan <shyam@codestax.ai>                                     *
 * -----                                                                       *
 * Last Modified: June 24th 2025, 5:58:48 pm                                   *
 * Modified By: Prakersh Arya                                                  *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */


import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies'; // Import vue-cookies
import { hospitalRoutes } from './hospitalBookingRoutes';
import { appointmentLinkSharingRoutes } from './appointmentLinkSharingRoutes';
Vue.use(VueRouter);
Vue.use(VueCookies); // Register vue-cookies globally
let routes = [
{
  path: '/customer/teleconsultationHome',
  name: 'CustomerHomeScreen',
  visibility: true,
  authentication: false,
  component: () => import('../views/Pages/Customer/homePage.vue')
},
{
  path: '/customer/home',
  name: 'CustomerHomeScreen2',
  visibility: true,
  authentication: false,
  component: () => import('../views/Pages/Customer/homePage.vue')
},
{
  path: '/customer/doctorconsultation',
  name: 'DoctorConsultationInfo',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/doctorConsultationInfo.vue')
},
{
  path: '/customer/viewDoctors',
  name: 'viewDoctors',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/viewDoctors.vue')
},
{
  path: '/customer/carecompanion',
  name: 'CareCompanionInfo',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/careCompanionInfo.vue')
},
{
  path: '/customer/kbzcare',
  name: 'KbzCaresInfo',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/kbzCaresInfo.vue')
},
{
  path: '/customer/addLinkedContact',
  name: 'AddLinkedContact',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/addLinkedContact.vue')
},
{
  path: '/customer/myLinkedContacts',
  name: 'MyLinkedContacts',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/myLinkedContacts.vue')
},
{
  path: '/customer/editLinkedContact/:linkedContactId',
  name: 'EditLinkedContact',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/editLinkedContact.vue')
},
{
  path: '/customer/bookappointment',
  name: 'BookAppointment',
  visibility: false,
  authentication: false,
  component:  () =>port('../views/Pages/Customer/BookAppointment.vue')
},
{
  path: '/customer/listOfWalkinDoctor',
  name: 'ListOfWalkinDoctor',
  visibility: true,
  authentication: false,
  component:  () =>port('../views/Pages/Customer/ListOfWalkinDoctor.vue')
},
{
  path: '/customer/listofSpecDoctors/:id',
  name: 'ListofSpecDoctors',
  visibility: false,
  authentication: false,
  component:  () =>port('../views/Pages/Customer/ListOfSpecDoctors.vue')
},
{
  path: '/customer/walkinBookAppointment/:doctor_id',
  name: 'WalkinBookAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component:  () =>port('../views/Pages/Customer/walkinBookAppointment.vue')
},
{
  path: '/customer/specBookAppointment/:doctor_id',
  name: 'SpecializedBookAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component:  () =>port('../views/Pages/Customer/SpecBookAppointment.vue')
},
{
  path: '/customer/bookedSuccess',
  name: 'bookedSuccess',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/bookedSuccess.vue')
},
{
  path: '/customer/myOffers/',
  name: 'MyOffers',
  visibility: true,
  authentication: true,
  meta: {
    authentication: true,
  },
  component:  () => import('../views/Pages/Customer/myOffers.vue')
},
{
  path: '/customer/viewPrescription/:appointment_reference_number',
  name: 'viewPrescription',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/viewPrescription.vue')
},
{
  path: '/signup',
  name : 'SignUp',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Login/SignupPage.vue')
},
{

  path: '/verify',
  name : 'Verify',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Login/LoginPage.vue')
},
{
  path: '/login',
  name : 'Login',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Login/loginLandingPage.vue')
},
{

  path: '/verifyOTP',
  name : 'VerifyOTP',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Login/OTPLogin.vue')
},
{
  path: '/customer/profile',
  name : 'UserProfile',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/userProfile.vue')
},
{
  path: '/customer/address',
  name : 'MyAddressbook',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/epharmacy/myAddressBook.vue')
},
{
  path: '/customer/addAddress',
  name : 'AddAddress',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/epharmacy/addAddress.vue')
},
{
  path: '/customer/editAddress/:addressID',
  name : 'EditAddress',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/epharmacy/editAddress.vue')
},
{
  path: '/customer/language',
  name : 'Language',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/Language.vue')
},
{
  path: '/customer/termsandconditions',
  name : 'TermsAndConditions',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/TermsAndConditions.vue')
},
{
  path: '/customer/epharmacytermsandconditions',
  name : 'ePharmacyTermsAndConditions',
  component: () => import('../views/Pages/Customer/epharmacy/ePharmacyTermsAndConditions.vue')
},
{
  path: '/customer/faq',
  name : 'FAQ',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/FAQ.vue')
},
{
  path: '/customer/listOfDevices',
  name : 'ListOfDevices',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/listOfDevices.vue')
},
{
  path: '/customer/myfamily',
  name : 'MyFamily',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/myfamily.vue')
},
{
  path: '/customer/mySubscription',
  name : 'MySubscription',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/mySubscription.vue')
},
{
  path: '/customer/myParticularSubscription/:packageName/:packageID',
  name : 'MyParticularSubscription',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/ViewParticularSubscription.vue')
},
{
  path: '/customer/addDependent',
  name: 'AddDependent',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/addDependent.vue')
},
{
  path: '/customer/editDependent/:dependent_id',
  name: 'EditDependent',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/editDependent.vue')
},
{
  path: '/careCompanion',
  name: 'careCompanion',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/careCompanion.vue')
},
{
  path: '/customer/feedback/:booking_id',
  name: 'Feedback',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/Feedback.vue')
},
{
  path: '/doctor/myprofile',
  name: 'DoctorProfile',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/profilePage.vue')
},
{
  path: '/doctor/appointmentHistory',
  name: 'AppointmentHistory',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/appointmentHistory.vue')
},
{
  path: '/doctor/cpivideoCallPage/:appointmentID/:token',
  name: 'CPIVideoCallPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/CPIVideoCallPrescriptionPage.vue')
},
{
  path: '/doctor/quickhelpvideoCallPage/:appointmentID/:token',
  name: 'QuickHelpVideoCallPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/quickHelpVideoCallPrescriptionPage.vue')
},
{
  path: '/doctor/externalappointmentHistory',
  name: 'CPIAppointmentHistory',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/externalAppointmentHistory.vue')
},
{
  path: '/doctor/write_prescription/:prescription_id',
  name : 'WritePrescription',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/Prescription.vue')
},
{
  path: '/doctor/viewPrescription/:prescription_id',
  name : 'ViewPrescription',
    visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/viewPrescription.vue')
},
{
  path: '/customer/viewAppointment/:booking_id',
  name: 'viewAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/viewAppointment.vue')
},
{
  path: '/customer/verifyAppointment',
  name: 'verifyAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/verifyAppointment.vue')
},
{
  path: '/customer/myBookings/',
  name: 'myBookings',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/mybookings.vue')
},

{
  path: '/customer/OTPSignup/',
  name: 'OTPSignup',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Login/OTPSignupPage.vue')
},
{
  path: '/customer/OTPLogin/',
  name: 'OTPLogin',
  visibility: false,
  authentication: false,
  component:  () => import('../views/Pages/Login/OTPLoginPage.vue')
},
{
  path: '/welcomePage',
  name: 'welcomePage',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/welcome.vue')
},
{
  path: '/welcome',
  name: 'welcome',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/welcome.vue')
},
{
  path: '/admin',
  redirect: '/admin/appointments',
},
{
  path: '/admin/appointments',
  name : 'AdminHome',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/adminHome.vue')
},
{
  path: '/admin/makejoinable',
  name : 'MakeJoinable',
  visibility: false,
  authentication: true,
  component: () => import('../views/Pages/Admin/MakeJoinable.vue')
},
{
  path: '/admin/AllCoupons',
  name : 'AllCoupons',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/AllCoupons.vue')
},
{
  path: '/admin/viewCouponFamily/:couponfamily_id',
  name : 'viewCouponFamily',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewCouponFamily.vue')
},
{
  path: '/admin/AllPromos',
  name : 'AllPromos',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/AllPromo.vue')
},
{
  path: '/admin/offers',
  name : 'Offers',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/allOffers.vue')
},
{
  path: '/admin/viewOffer/:offerName&:offerStatus&:createdAt',
  name : 'ViewOffers',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewParticularOffer.vue')
},

{
  path: '/admin/viewPromo/:promotion_id',
  name : 'viewPromoDetails',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewPromoDetails.vue')
},
{
  path: '/admin/AllCorporatePackages',
  name : 'AllCorporatePackages',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/AllCorporatePackages.vue')
},
{
  path: '/admin/CreateCorporatePackage',
  name : 'CreateCorporatePackage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/createCorporatePackage.vue')
},
{
  path: '/admin/AddBenefitsToPackage/:package_id',
  name : 'AddBenefitsToPackage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/addBenefitsToPackage.vue')
},
{
  path: '/admin/CorporateMemberList/:package_id',
  name : 'CorporateMemberList',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/corporateMemberList.vue')
},
{
  path: '/admin/ViewCorporatePackage/:package_id',
  name : 'ViewCorporatePackage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewCorporatePackage.vue')
},
{
  path: '/admin/EditBenefitsCorporatePackage/:package_id',
  name : 'EditBenefitsCorporatePackage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/editBenefitsCorporatePackage.vue')
},
{
  path: '/admin/WalkIn',
  name : 'WalkIn',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import(/* webpackChunkName: "AllWalkins" */ '../views/Pages/Admin/DoctorWalkinDashboard.vue')
},
{
  path: '/admin/viewPatientDevices/:user_id',
  name : 'ViewPatientDevices',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/adminPatientDevices.vue')
},
{
  path: '/admin/viewSpecialization',
  name : 'ViewSpecialization',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewSpecialization.vue')
},
{
  path: '/admin/editSpecialization/:specialization_id',
  name: 'EditSpecialization',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/editSpecialization.vue')
},
{
  path: '/admin/viewHighlightSpeciality',
  name : 'ViewHighlightSpec',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/viewFeatureSpec.vue')
},
{
  path: '/admin/editSuggestion/:suggestion_id',
  name: 'EditSuggestion',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/editSuggestion.vue')
},
{

  path: '/admin/rescheduleAppointment/:booking_id',
  name : 'rescheduleAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/rescheduleAppointment.vue')
},
{
  path: '/doctor/appointments',
  name: 'DoctorHome',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/Home.vue')
},
{
  path: '/doctor/cpiappointments',
  name: 'DoctorCPIHome',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/CPIHome.vue')
},
{
  path: '/doctor/viewAllPatients',
  name: 'DoctorViewAllPatient',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/viewAllPatients.vue')
},
{

  path: '/doctor/login',
  name : 'DoctorLogin',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Doctor/loginPage.vue')
},
{
  path: '/admin/generateSlots',
  name: 'GenerateSlots',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/assignDoctorTiming.vue')
},
{
  path: '/admin/SlotsManagement',
  name: 'SlotsManagement',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/slotManagement.vue')
},
{
  path: '/admin/assignDoctors',
  name: 'AssignDoctors',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/assigndoctors.vue')
},
{
  path: '/admin/ViewAppointment/:booking_id',
  name: 'AdminViewAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/adminviewappointment.vue')
},
{

  path: '/admin/login',
  name : 'AdminLogin',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Admin/loginPage.vue')
},
{
  path: '/doctor/videocall/:booking_id',
  name: 'JoinVideoCallDoctor',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/videoCall.vue')
},
{
  path: '/doctor/videocallTokBox/:booking_id',
  name: 'JoinVideoCallDoctorTokBox',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/videoCallTokBoxDoc.vue')
},
{
  path: '/doctor/videocallTwilio/:booking_id',
  name: 'JoinVideoCallDoctorTwilio',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/videoCallTwilioDoc.vue')
},
{
  path: '/admin/videocallTwilio/:booking_id',
  name: 'JoinVideoCallAdminTwilio',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/adminVideoCallTwilio.vue')
},
{
  path: '/customer/videocall/:booking_id',
  name: 'JoinVideoCallCustomer',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/videoCall.vue')
},
{
  path: '/customer/videocallTokBox/:booking_id',
  name: 'JoinVideoCallCustomerTokBox',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/videoCallTokBox.vue')
},
{
  path: '/customer/videocallTwilio/:booking_id',
  name: 'JoinVideoCallCustomerTwilio',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/videoCallTwilio.vue')
},
{
  path: '/customer/videocallInfoPage/:booking_id/:pin',
  name: 'VideoCallInfoPageThirdParty',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/VideoCallInforThirdParty.vue')
},
{
  path: '/customer/Packages',
  name: 'Packages',
  visibility: true,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/Packages.vue')
},
{
  path: '/doctor/viewappointment/:booking_id',
  name: 'ViewAppointmentDoctor',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Doctor/viewAppointment.vue')
},
{
  path: '/admin/markactivedoctors',
  name: 'MarkActiveDoctors',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/doctorsList.vue')
},
{
  path: '/admin/changePatientNumber/:customer_id',
  name: 'ChangePatientNumber',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/changePatientNumber.vue')
},
{
  path: '/admin/viewalldoctors',
  name: 'ViewAllDoctors',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/allDoctors.vue')
},
{
  path: '/admin/suggestions',
  name: 'ViewAllSuggestions',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/allSuggestions.vue')
},
{
  path: '/admin/viewallpatient',
  name: 'ViewAllPatients',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/allPatient.vue')
},
{
  path: '/admin/editdoctor/:doctor_id',
  name: 'EditDoctor',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/doctors.vue')
},
{
  path: '/doctor/doctorViewPatientDetails/:patient_id',
  name: 'DoctorViewPatientDetails',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Doctor/doctorViewPatientDetails.vue')
},
{
  path: '/admin/createadmin',
  name: 'CreateAdmin',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/createAdmin.vue')
},
{
  path: '/admin/createdoctor',
  name: 'CreateDoctor',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/createdoctor.vue')
},
{
  path: '/admin/adminCreateAppointment',
  name: 'AdminCreateAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/adminCreateAppointment.vue')
},
{
  path: '/admin/externalAppointment',
  name: 'ExternalAppointmentList',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/externalAppointmentList.vue')
},
{
  path: '/admin/quickhelpAppointment',
  name: 'QuickHelpAppointmentList',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/quickhelpAppointmentList.vue')
},
{
  path: '/admin/createCPIAppointment',
  name: 'CreateCPIAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/createCPIAppointment.vue')
},
{
  path: '/admin/createQuickHelpAppointment',
  name: 'CreateQuickHelpAppointment',
  visibility: false,
  authentication: true,
   meta: {
    authentication: true,
  },
  
  component: () => import ('../views/Pages/Admin/createQuickHelpAppointmentPage.vue')
},
{
  path: '/admin/viewParticularAppointment/:booking_id',
  name: 'ViewParticularAppointment',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/viewParticularAppointment.vue')
},
{
  path: '/admin/AdminViewPrescription/:booking_id',
  name: 'AdminViewPrescription',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/AdminViewPrescription.vue')
},
{
  path: '/admin/createspecialization',
  name: 'createSpecialization',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/createSpecialization.vue')
},
{
  path: '/admin/createSuggestion',
  name: 'CreateSuggestion',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Admin/createSuggestion.vue')
},
{
  path : '/customer/QRcode',
  name : 'QRCode',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Customer/QRcode.vue')
},
{
  path : '/customer/bookingcardDetails',
  name : 'BookingCardDetails',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Customer/bookingcardDetails.vue')
},
{
  path : '/customer/homePage',
  name : 'OldCustomerHome',
  visibility: false,
  authentication: false,
  component: () => import ('../views/Pages/Customer/Home.vue')
},
{
  path : '/customer/newBookingPage/:docId&:walkIn',
  name : 'newBookingPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import ('../views/Pages/Customer/newBookingPage.vue')
},
{
  path : '/customer/specializations',
  name : 'SpecializationsPage',
  visibility: true,
  authentication: false,
  component: () => import ('../views/Pages/Customer/allSpecializationsPage.vue')
},
{
  path: '/admin/serviceDoctorDashboard',
  name : 'ServiceDoctorDashboard',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/serviceDoctorDashboard.vue')
},
{
  path: '/customer/editUserProfile',
  name : 'EditUserProfile',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Customer/editUserProfile.vue')
},
{
  path: '/searchpage',
  name : 'SearchPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/SearchPage.vue'),
  props: true
},
{
  path: '/admin/commonhomepage',
  name : 'CHP',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/CommonHomePage.vue')
},
{
  path: '/admin/epharmacyhomepage',
  name : 'EHP',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/EpharmacyHomePage.vue')
},
{
  path: '/admin/segments',
  name : 'Segments',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/SegmentsPage.vue')
},
{
  path: '/admin/megamenu',
  name : 'MegaMenu',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/MegaMenuPage.vue')
},
{
  path: '/admin/bannerPage',
  name : 'BannerPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/BannerPage.vue'),
  props: true
},
{
  path: '/admin/usermanagement',
  name : 'UserManagement',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/UserManagement.vue'),
  props: true
},
{
  path: '/admin/createnewuser',
  name : 'CreateNewUserPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/CreateNewUserPage.vue'),
  props: true
},
{
  path: '/admin/createnewaddress',
  name : 'CreateAddressForNewUser',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/CreateAddressForNewUser.vue'),
  props: true
},
{
  path: '/admin/updateuserdetails/:customer_id',
  name : 'UpdateUserManagement',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/Pages/Admin/UpdateUserManagement.vue')
},
{
  path: "*",
  visibility: false,
  authentication: false,
  component: () => import('../views/PageNotFound.vue')
},
{
  path: '/',
  name : 'CommonHomePage',
  visibility: true,
  authentication: false,
  component: () => import('../views/commonHomePage.vue')
},
{
  path: '/customer/searchMobile',
  name: 'SearchMobilePage',
  visibility: false,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/searchMobilePage.vue')
},
{
  path: '/customer/orderSuccess',
  name : 'OrderSuccessPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/orderSuccessPage.vue')
},
{
  path: '/customer/myOrders',
  name: 'MyOrdersPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/ePharmacyPages/customer/myOrdersPage.vue')
},
{
  path: '/customer/orderDetailsPage/:orderID',
  name: 'Order Details',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/ePharmacyPages/customer/orderDetailsPage.vue')
},
{
  path: '/customer/ePharmacyHome',
  name : 'ePharmacyHomePage',
  visibility: true,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/ePharmacyHomePage.vue')
},
{
  path: '/customer/ePharmacyOdooHome/:source',
  name : 'ePharmacyOdooHome',
  visibility: true,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/ePharmacyOdooHome.vue')
},
{
  path: '/customer/catalog/:catalog_name/:category_id',
  name : 'CatalogPage',
  visibility: true,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/catalogPage.vue')
},
{
  path: '/customer/allcategories',
  name : 'AllCategoriesPage',
  visibility: true,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/allCategoriesPage.vue')
},
{
  path: '/customer/productdetails/:product_id',
  name : 'ProductDetailsPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/ePharmacyPages/customer/productDetailsPage.vue')
},
{
  path: '/nurseBooking',
  name : 'nurseBooking',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/bookingPage.vue')
},
{
  path: '/nurse/AppointmentSuccessPage/:bookingID',
  name : 'AppointmentSuccessPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/successScreen.vue')
},
{
  path: '/nurseDetails/:nurseID',
  name : 'nurseDetails',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/nurseDetails.vue')
},
{
  path: '/nurseBooking/addAddress',
  name : 'NBACustomerAddAddress',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/addAddressPage.vue')
},
{
  path: '/nurseBooking/editAddress/:addressID',
  name : 'NBACustomerEditAddress',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/editAddressPage.vue')
},
{
  path: '/nurseBooking/addDependent',
  name : 'NBACustomerAddDependent',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/addDependentPage.vue')
},
{
  path: '/summaryPage',
  name : 'summaryPage',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/summaryPage.vue')
},
{
  path: '/nurseBooking/cancellation/:bookingID',
  name : 'NBACustomerCancellation',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/cancelAppointmentPage.vue')
},
{
  path: '/appointments',
  name : 'appointments',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/appointments.vue')
},
{
  path: '/bookingDetails/:bookingID',
  name : 'bookingDetails',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/bookingDetails.vue')
},
// {
//   path: '/customer/cart',
//   name : 'ePharmacyCartPage',
//   component: () => import('../views/ePharmacyPages/customer/cartPage.vue')
// },
{
  path: '/customer/cart/:cart_id',
  name : 'ePharmacyCartPage',
  visibility: false,
  authentication: true,
  meta: {
    authentication: true,
  },
  component: () => import('../views/ePharmacyPages/customer/cartPage.vue')
},
{
  path: '/customer/cart',
  name : 'ePharmacyCartPageWithoutPrescriptionFlow',
  component: () => import('../views/ePharmacyPages/customer/cartPageWithoutPrescriptionFlow.vue')
},
{
  path: '/customer/nurseBooking',
  name : 'NurseBookingCommonPage',
  component: () => import('../views/nursePage/customer/nurseBooking.vue')
},
{
  path: '/healthArticles',
  name : 'HealthArticles',
  visibility: false,
  authentication: false,
  component: () => import('../views/nurseBookingPages/iFrameForHealthArticles.vue')
},
{
  path: '/commonSuccess',
  name : 'CommonSuccess',
  visibility: false,
  authentication: false,
  component: () => import('../views/Pages/Customer/commonSuccessPage.vue')
},
{
  path: '/videoCallPage/:appointmentID/:token/:bookingID',
  name: 'ThirdPersonVideoCallPage',
  authentication: false,
  component: () => import('../views/Pages/Customer/thirdPersonVideoCallPage.vue')
},
/* VIDEO CALL ROUTES */
// {
//   path: '/videocall',
//   name: 'VideoCallPage',
//   component: () => rn import('../views/Pages/VideoCall/call.vue')
// 
// },
// {
//   path: '/videoCallServiceTestPage',
//   name: 'videoCallServiceTestPage',
//   component:  () => import('../views/Pages/Customer/videoCallServiceTestPage.vue
// },
// {
//   path: '/wherebyTestPage',
//   name: 'WherebyTestPage',
//   component:  () => import('../views/Pages/Customer/wherebyTestPage.vue
// },
// {
//   path: '/tokBoxTestPage',
//   name: 'TokBoxTestPage',
//   component:  () => import('../views/Pages/Customer/tokBoxTestPage.vue
// },
// {
//   path: '/customer/dolbyDemoPage/',
//   name: 'DolbyDemoPage',
//   component:  () => import('../views/Pages/Customer/dolbyDemoPage.vue')
// },
// {
//   path: '/customer/videoCallTestPage',
//   name : 'VideoCallTestPage',
//   component: () => import('../views/Pages/Customer/videoCallTestPage.vue')
// },
// {
//   path: '/customer/AgoraVideoCallTestPage',
//   name: 'AgoraTestPage',
//   component: () => import('../views/Pages/VideoCall/agora_test.vue')
// },
// {
//   path: '/customer/TwilioVideoCallTestPage',
//   name: 'TwilioTestPage',
//   component: () => import('../views/Pages/VideoCall/twilio_test.vue')
// },
// {
//   path: '/customer/DolbyTestPage',
//   name: 'DolbyTestPage',
//   component: () => import('../views/Pages/VideoCall/dolby_test.vue')
// },
]
//opdbooking routes
routes = routes.concat(hospitalRoutes);
//appointment link sharing routes
routes = routes.concat(appointmentLinkSharingRoutes);
const router = new VueRouter({
  routes,
  scrollBehavior (to, from,  savedPosition) {
    document.body.scrollTop = 0
  },
  mode: 'history',
  base: process.env.BASE_URL,
});
function isAuthenticated(fullPath) {
  let tokenInKBZApp = localStorage.getItem("customerToken");
  if (fullPath.includes('/doctor/') || fullPath.includes('/admin/') || tokenInKBZApp)
    return true; // no redirection
  else
    return Vue.$cookies.get("customerToken") !== null;   
}
router.beforeEach((to, from, next) => {  
  console.log(to);
  if (to.matched.some(record => record.meta.authentication) && !isAuthenticated(to.fullPath)) {   
    next({ path: '/login', query: { redirect: to.fullPath } }); // Store the route
  } else {
    next();
  }
});


export default router;
